import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../reducers/authReducer';
import eventReducer from '../reducers/eventReducer';

const store = configureStore({
  reducer: {
    auth: authReducer,
    event: eventReducer,
  },
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;